import { render, staticRenderFns } from "./task-edit-mode.vue?vue&type=template&id=6aa43f91&scoped=true"
import script from "./task-edit-mode.vue?vue&type=script&lang=js"
export * from "./task-edit-mode.vue?vue&type=script&lang=js"
import style0 from "./task-edit-mode.vue?vue&type=style&index=0&id=6aa43f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa43f91",
  null
  
)

export default component.exports